export const ROUTES_FOR_NOMENCLATURE_EDITOR = [
  '/',
  '/catalog-approval',
  '/categories-catalog',
  '/characteristics-catalog',
  '/nomenclature-groups-catalog',
  '/nomenclature-feed',
  '/exchanges',
  '/nomenclature-import',
  '/attribute-processing',
]

export const SEARCH_PAGE_TITLES = {
  CLIENT_SELECTION_PENDING: 'Поиск товаров для закупки',
  PROCUREMENT: 'Поиск товаров для закупки',
  CLIENT_SALE_BY_OWNER: 'Поиск товаров для продажи',
  PARTNER_SALE: 'Поиск товаров для продажи',
  CLIENT_SELF_SERVICE: 'Поиск товаров',
} as const

export const enableScrollRestorationFor = [
  '/system/priority-config',
  '/feed',
  '/nomenclature-feed',
  '/organisations/:code/settings',
  '/cart',
  '/order',
  '/order/success',
  '/profile',
  '/profile/construction-sites/archive',
  '/profile/orders/:code',
  '/profile/construction-sites/:id',
  '/login',
  '/register',
  '/register/success',
  '/nomenclature-import',
]

export const ALLOWED_ROUTES_WITHOUT_TOKEN = ['/login', '/import']
